<template>
  <q-page class="main-wrapper-page single-page" style="background-color: var(--q-accent)">
    <section class="widget-section widget-section--filter flex no-wrap items-center q-mb-lg">
      <q-form ref="form" class="full-width">
        <div class="row no-wrap full-width q-col-gutter-sm">
          <div class="col flex no-wrap q-col-gutter-sm">
            <q-input
              v-model="filters.id"
              label="Item ID"
              outlined
              class="full-width"
              dense
              clearable
              :rules="[validateUuid]"
              @update:model-value="filterTable"
            ></q-input>
            <q-input
              v-model="filters.registrationId"
              label="Registration ID"
              outlined
              class="full-width"
              dense
              clearable
              :rules="[validateUuid]"
              @update:model-value="filterTable"
            ></q-input>
          </div>
          <div class="col flex no-wrap q-col-gutter-sm">
            <q-select
              v-model="filters.scope"
              @update:model-value="reloadTable"
              emit-value
              class="full-width"
              label="Scope"
              clearable
              map-options
              dense
              outlined
              :options="['external', 'internal']"
            />
            <q-input
              v-model="filters.changeNumber"
              label="Change request number"
              outlined
              dense
              clearable
              class="full-width"
              @update:model-value="filterTable"
            ></q-input>
          </div>
        </div>
        <div class="row no-wrap full-width q-col-gutter-sm">
          <div class="col flex no-wrap q-col-gutter-sm">
            <q-input
              v-model="filters.name"
              label="Name"
              outlined
              dense
              clearable
              class="full-width"
              @update:model-value="filterTable"
            ></q-input>
            <q-input
              v-model="filters.domain"
              label="Domain"
              outlined
              dense
              clearable
              class="full-width"
              @update:model-value="filterTable"
            ></q-input>
          </div>
          <div class="col flex no-wrap q-col-gutter-sm">
            <q-select
              v-model="filters.type"
              :options="['A', 'AAAA', 'CNAME', 'CNAME-WITH-REDIRECT', 'TXT', 'NS', 'MX', 'SRV']"
              emit-value
              map-options
              options-dense
              label="Type"
              outlined
              dense
              clearable
              class="full-width"
              @update:model-value="reloadTable"
              @clear="
                () => {
                  filters.dns_enabled = undefined;
                }
              "
            ></q-select>
            <q-input
              v-model="filters.value"
              label="Value"
              outlined
              dense
              clearable
              class="full-width"
              @update:model-value="filterTable"
            ></q-input>
          </div>
        </div>
        <div class="row no-wrap full-width q-mt-sm q-mb-xs q-col-gutter-sm">
          <div class="col flex no-wrap q-col-gutter-sm">
            <q-input
              v-model="filters.digitalService"
              label="Digital Service"
              outlined
              dense
              clearable
              @update:model-value="filterTable"
              class="full-width"
            ></q-input>
            <StatusSelect
              v-model="filters.status"
              @update:model-value="reloadTable"
              class="full-width"
              :options="['inprogress', 'completed', 'failed', 'removed']"
            />
          </div>
          <div class="col flex no-wrap q-col-gutter-sm">
            <DatePicker
              v-model="filters.dateFrom"
              @update:model-value="reloadTable"
              label="Created after"
              class="full-width"
              @clear="
                () => {
                  filters.dateFrom = undefined;
                }
              "
            />
            <DatePicker
              v-model="filters.dateTo"
              @update:model-value="reloadTable"
              label="Created before"
              class="full-width"
              @clear="
                () => {
                  filters.dateTo = undefined;
                }
              "
            />
          </div>
        </div>
      </q-form>
      <q-icon @click="resetFilters" name="engp:engp-ico-restart" class="q-ml-md cursor-pointer" size="20px">
        <q-tooltip>Reset</q-tooltip>
      </q-icon>
    </section>
    <section class="widget-section widget-section--table">
      <DnsRecordsTable
        ref="dnsTable"
        :rowsPerPageOptions="[20, 50, 100]"
        class="fixed-table"
        mode="list"
        :filters="filters"
      />
    </section>
  </q-page>
</template>

<script>
import StatusSelect from './components/StatusSelect.vue';
import DatePicker from './components/DatePicker.vue';
import DnsRecordsTable from '@/shared/components/DnsRecordsTable.vue';

export default {
  name: 'DnsRecords',
  components: {
    StatusSelect,
    DatePicker,
    DnsRecordsTable,
  },
  data() {
    return {
      loading: false,
      timeout: undefined,
      filters: {
        scope: undefined,
        id: undefined,
        registrationId: undefined,
        digitalService: undefined,
        infraService: undefined,
        changeNumber: undefined,
        name: undefined,
        domain: undefined,
        type: undefined,
        value: undefined,
        dateFrom: undefined,
        dateTo: undefined,
        status: undefined,
      },
    };
  },
  methods: {
    validateUuid(value) {
      const uuidRegex =
        // eslint-disable-next-line
        /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
      return value?.length ? uuidRegex.test(value) || 'Must be a valid UUID' : true;
    },
    resetFilters() {
      Object.keys(this.filters).forEach((key) => {
        this.filters[key] = undefined;
      });
      this.reloadTable();
    },
    filterTable() {
      this.$refs.form.validate().then((valid) => {
        if (valid) {
          this.loading = true;
          if (this.timeout) clearTimeout(this.timeout);
          this.timeout = setTimeout(async () => {
            this.reloadTable();
          }, 1500);
        }
      });
    },
    reloadTable() {
      this.$refs.dnsTable.reload();
    },
  },
  mounted() {
    const query = this.$route.query;

    Object.keys(this.filters).forEach((key) => {
      this.filters[key] = query[key] || undefined;
    });
    this.reloadTable();
  },
};
</script>

<style lang="scss" scoped>
.long-desc {
  max-width: 300px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.showBanner {
  .fixed-table {
    height: calc(100vh - 420px);
  }
}
.fixed-table {
  height: calc(100vh - 360px);
}
</style>
